<template>
    <div v-if="show">
        <h2 class="title is-2 section-header">
            Create datamagnet for library..
        </h2>
        <div class="block">
            <b-field label="Library Name">
                <b-input v-model="libraryName" />
            </b-field>
            <b-field label="Application Name">
                <b-input v-model="applicationName" />
            </b-field>
            <b-field>
                <b-switch v-model="dryRun">
                    Dry run (rollback transaction)
                </b-switch>
            </b-field>
        </div>
        <div class="buttons">
            <b-button
                type="is-primary"
                :disabled="!enabled"
                @click="run()">
                Run
            </b-button>
            <b-button
                :disabled="!enabled"
                @click="cancelCommand()">
                Cancel
            </b-button>
        </div>
    </div>
</template>

<script>
    import runMixin from './RunMixin.js';

    export default {
        mixins: [runMixin],
        data() {
            return {
                libraryName: '',
                applicationName: '',
                dryRun: true
            };
        },
        methods: {
            async run() {
                await this.submitCommand([
                    'create-datamagnet',
                    this.libraryName,
                    this.applicationName,
                    this.dryRun ? 'dry-run' : ''
                ]);
            }
        }
    };
</script>
